export default __webpack_public_path__ + "static/automate-do-1-dark-abb1e05cb7eb910bc56eeeff635757ba.png";